const NiueSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112037)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C0 20.0048 20 0.0021875 20 0C31.0456 0 40 8.95437 40 20Z"
        fill="#FFDA44"
      />
      <path d="M19.9999 9.56543V16.311L13.0435 9.56543H19.9999Z" fill="#0052B4" />
      <path
        d="M10.4345 19.9989H16.3103L10.4345 12.1729L9.56494 18.2598L10.4345 19.9989Z"
        fill="#0052B4"
      />
      <path
        d="M19.9468 19.9998H20.0003C20.0003 19.9818 20.0003 19.9643 20.0003 19.9463C19.9825 19.9642 19.9647 19.982 19.9468 19.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 10.4348C20 6.91563 20 4.60977 20 0H19.9966C8.95242 0.001875 0 8.95539 0 20H10.4348V14.1241L16.3106 20H19.9466C19.9644 19.9822 19.9822 19.9644 20.0001 19.9465C20.0001 18.5991 20.0001 17.3968 20.0001 16.3108L14.1241 10.4348H20Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9993 17.5403L12.8935 10.4346H10.4341V10.4347L19.9992 19.9997H19.9993C19.9993 19.9997 19.9993 18.3039 19.9993 17.5403Z"
        fill="#D80027"
      />
      <path
        d="M10.1181 2.6084C9.34707 3.04746 8.6084 3.53676 7.9059 4.0709H8.72652L6.55762 5.64699L7.3859 8.19676L5.21699 6.62098L4.98621 6.78871C4.08566 7.81137 3.28723 8.92605 2.6084 10.1181V19.9997H7.82582V7.82598V7.82582H19.9997C19.9997 6.18027 19.9997 4.61262 19.9997 2.6084H10.1181Z"
        fill="#D80027"
      />
      <path
        d="M8.54367 3.60645C8.32797 3.75746 8.11531 3.9127 7.90586 4.07199L6.55781 5.64809L5.21719 6.62199L4.98445 6.79105C4.49336 7.34887 4.03281 7.93418 3.60547 8.54457C4.09258 8.78098 4.63937 8.91387 5.21719 8.91387C7.25828 8.91387 8.91281 7.25934 8.91281 5.21824C8.91297 4.64027 8.78016 4.09363 8.54367 3.60645Z"
        fill="#0052B4"
      />
      <path
        d="M4.98486 6.79035L5.2176 6.62129L7.3865 8.19715L6.55814 5.64738L8.72689 4.07129H7.90611C6.84408 4.87902 5.86541 5.79027 4.98486 6.79035Z"
        fill="#FFDA44"
      />
      <path
        d="M13.8234 3.47852L14.2551 4.80703H15.652L14.5219 5.6282L14.9534 6.95672L13.8234 6.13562L12.6933 6.95672L13.1247 5.6282L11.9946 4.80703H13.3916L13.8234 3.47852Z"
        fill="#FFDA44"
      />
      <path
        d="M5.21734 12.1729L5.64906 13.5014H7.04594L5.91594 14.3226L6.34742 15.6511L5.21734 14.83L4.08719 15.6511L4.51867 14.3226L3.38867 13.5014H4.78555L5.21734 12.1729Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112037">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default NiueSvg;
